module.exports = __webpack_public_path__ + "components/t-shirt-comp/static/t-shirt-icon-9ff4ef1c916c94c4cb08a52a72daac73.png";